import React from 'react';
import SpreadReadingPage from './SpreadReadingPage';

const config = {
  pickerPage: 'sixCard',
  path: '/six-card-tarot-spread/',
  spreadId: 'sixCardUniversal',
  cardCount: 6,
  metaTitle: 'Free 6 Card Tarot Spread Reading Online | NowTarot AI',
  metaDescription:
    'Get a free 6 card tarot reading. Explore how you feel, what you desire and fear, what is working for and against you, and the likely outcome. 100% free, no signup.',
  metaKeywords:
    '6 card tarot spread, six card tarot reading, free 6 card tarot, universal tarot spread, 6 card tarot reading online',
  heading: '6 Card Tarot Spread',
  intro:
    'Want more depth than three cards but less than a full Celtic Cross? This free 6 card tarot spread explores your inner world and the forces around you: how you feel, what you desire, what you fear, what is working for and against you, and where things are heading. 100% free, no signup required.',
  howItWorks:
    'Hold your question or situation in mind, then shuffle the deck and pick six cards. The cards answer six questions in order: how you feel, what you desire, what you fear, what is working for you, what is working against you, and the likely outcome.',
  contentSections: [
    {
      heading: 'The Six Positions of the Universal Spread',
      items: [
        {
          title: '1. How You Feel',
          text: 'Your current emotional state and inner feelings about the situation, often the part you have not said out loud yet.',
        },
        {
          title: '2. What You Desire',
          text: 'What you truly want. This can differ from what you think you should want, which is often where the insight lies.',
        },
        {
          title: '3. What You Fear',
          text: 'The fear holding you back. Naming it is usually the first step to taking away its power.',
        },
        {
          title: '4. Working For You',
          text: 'Strengths, people, and circumstances on your side. Lean on these as you move forward.',
        },
        {
          title: '5. Working Against You',
          text: 'Obstacles and challenges to overcome, whether outside you or your own habits.',
        },
        {
          title: '6. Final Outcome',
          text: 'The likely resolution if the current energies continue. Remember that your choices can still change it.',
        },
      ],
    },
    {
      heading: 'When to Choose the 6 Card Spread',
      items: [
        {
          title: 'Mixed Feelings',
          text: 'When you want something but feel anxious about it, the desire and fear positions side by side make the conflict easy to see.',
        },
        {
          title: 'Weighing a Situation',
          text: 'The "working for" and "working against" positions give a quick pros-and-cons view of any situation: love, work, or a personal goal.',
        },
        {
          title: 'More Than 3, Less Than 10',
          text: 'Use the 3-card spread for a quick check-in and the Celtic Cross for a full deep dive. The 6 card spread sits in between.',
        },
      ],
    },
  ],
  faqHeading: '6 Card Tarot Spread FAQ',
  faq: [
    {
      question: 'What is the 6 card universal tarot spread?',
      answer:
        'It is a six-card layout that covers how you feel, what you desire, what you fear, what is working for you, what is working against you, and the final outcome. It works for almost any question, which is why it is called universal.',
    },
    {
      question: 'How long does a 6 card reading take?',
      answer:
        'Picking the cards takes about a minute, and your interpretation appears instantly. Spend a few extra minutes comparing the desire and fear cards; that is often where the clearest insight is.',
    },
    {
      question: 'Is a 6 card spread better than a 3 card spread?',
      answer:
        'Neither is better; they answer different needs. Three cards give a quick past, present, and future overview. Six cards add your emotions, fears, and the forces helping or blocking you.',
    },
    {
      question: 'Is this 6 card tarot reading free?',
      answer:
        'Yes! This 6 card tarot reading is 100% free with no signup or credit card required. For deeper, personalized guidance, ask our AI tarot reader in chat.',
    },
  ],
  crossLinks: (
    <>
      Want a different depth? Try the quick <a href="/three-card-tarot/" style={{ color: '#FFD700' }}>3-card reading</a>, the full{' '}
      <a href="/celtic-cross-tarot/" style={{ color: '#FFD700' }}>10-card Celtic Cross</a>, or explore{' '}
      <a href="/tarot-card-meanings/" style={{ color: '#FFD700' }}>the meaning of every tarot card</a> — all free, no signup required.
    </>
  ),
};

const SixCardTarot = () => <SpreadReadingPage config={config} />;

export default SixCardTarot;
